import { HttpClient } from "@angular/common/http";
import {Observable, throwError} from "rxjs";
import {catchError, map} from "rxjs/operators";
import {UrlService} from "../common/url.service";
import {Injectable} from "@angular/core";
import {IRestResponse} from "../common/rest-response.model";

@Injectable({
    providedIn: 'root'
})
export class SurveyService {
    constructor(
        private http: HttpClient,
        private urlService: UrlService
    ) {

    }

    getSurveyResults(surveyId: string): Observable<IRestResponse> {
        const params: { [param: string]: string } = {surveyId: surveyId};
        return this.http.get(this.urlService.buildCartUrl("/survey"), {params}).pipe(
            map((response: any) => response),
            catchError((error: any) => throwError(error))
        );
    }
}
